module.exports = __webpack_public_path__ + "static/img/zhexue.9a5858f5.jpg";